export const getAnalysisValueForGoalAndGroup = (goalId, groupId, values) => {
  const analysisUserGroup = values.find(analysisUserGroup =>
    (analysisUserGroup.analysisgoal === goalId) &&
    (analysisUserGroup.usergroup === groupId)
  );
  return analysisUserGroup && analysisUserGroup.value;
};




// WEBPACK FOOTER //
// ./src/utils/analysisUtils.js